// #429. The one source for the copy shown while the environment has no public payment keys:
// checkout cannot take a payment, so it cannot place an order at all. PaymentForm's alert,
// the disabled Place Order and the cart's disabled Checkout controls all read it here.
export const CHECKOUT_UNAVAILABLE_TITLE = "Checkout is unavailable";

export const CHECKOUT_UNAVAILABLE_MESSAGE =
    "We can't take payments online right now, so orders can't be placed. Please contact support to place your order.";

// The short form beside a disabled control.
export const CHECKOUT_UNAVAILABLE_REASON = `${CHECKOUT_UNAVAILABLE_TITLE} — please contact support`;
